import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createCoupon } from "../services/create-coupon";
import { toast } from "@/hooks/use-toast";
import { CouponFormData } from "../schema/coupon-schema";
import { getApiErrorMessage } from "@/helpers/get-api-error-message";

export function useCreateCoupon() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data: CouponFormData) => createCoupon(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["coupons"] });
      toast({ title: "Success", description: "Coupon created successfully"});
    },
    onError: (error) => {
      // Single error surface for the whole flow: the form's catch only logs,
      // this toast shows the server's specific message (response.data.message).
      toast({ title: "Error", description: getApiErrorMessage(error, "Failed to create coupon"), variant: "destructive" });
    },
  });
}
